import React from "react"
import PropTypes from "prop-types"

import Toggle from "shared/components/Toggle"
import Panel from "shared/components/Panel"

const Faq = (props, { t: translate }) => (
  <Panel>
    <h2 className="w400 fs-12">{translate("Frequently Asked Questions")}</h2>
    <div className="row">
      <div className="col-sm-12">
        <Toggle
          header={<h4 className="fs-16">How does this Service work?</h4>}
        >
          <p>
            This is a Parcel Forwarding service which enables Online Store owners to offer the best value international shipping. This program is built for Sellers to send their shipments locally to an international shipping hub, which is then processed by Webinterpret and international logistic carriers (this is why there will be a domestic address that will be different to the final destination address).
          </p>
        </Toggle>

        <Toggle
          header={<h4 className="fs-16">What are the stages involved with shipment and delivery?</h4>}
        >
          <p>
            As shown at the head of the page, there are four stages involved with processing and shipping an order, these are clarified below:
          </p>
          <p>
            <strong>Ordered:</strong> This means the order has been received by the store and is in the process of being readied for shipment to the local delivery hub for international shipping. Order confirmation will be sent to you and will include reference to a local domestic address which is the first stage hub before shipment to your final destination address.
            {" "}
            <strong>(Please note that any queries or questions up to this point should be referred to the point of purchase)</strong>.
          </p>
          <p>
            <strong>International Dispatch:</strong> The shipment has left the local hub and is on route to final destination country.
          </p>
          <p>
            <strong>In Transit:</strong> Shipment is in the final destination country and is being processed by a local carrier.
          </p>
          <p>
            <strong>Delivered:</strong> Shipment has been delivered to the buyer.
          </p>
        </Toggle>

        <Toggle
          header={<h4 className="fs-16">Can I contact the local carrier?</h4>}
        >
          <p>
            Once the shipment is on its way to or in the destination country you will see carrier information along with local carrier tracking numbers and a URL to the tracking website (there may be occasions where this carrier information is not displayed. If there is a gap in updated events, contact will need to be raised for carrier updates). Please note that only once the shipment is in the country of destination will the tracking of the shipment be available on the local website (prior to this tracking, this page will be the place to track up until this point.
          </p>
        </Toggle>

        <Toggle
          header={<h4 className="fs-16">How often should this page provide updated events?</h4>}
        >
          <p>
            Events  (such as location and or carrier changes) are updated  at varying stages and should provide a cohesive legend of progress. However, please do not be concerned if there are gaps in chronological terms. Various events will be synchronized immediately and other events will require longer processing time, such as international flight time etc.
          </p>
        </Toggle>

        <Toggle
          header={<h4 className="fs-16">In case of shipping delays</h4>}
        >
          <p>
            Please be aware that international shipping can, at times experience delays. If there is a gap in the events mentioned above, please note that this may be a natural progress through international logistics and we will update the tracking accordingly. When making an order through our Online Store partners, an ETA (estimated time of arrival) will be displayed ie 9-12 days. Please contact us only if the time estimated has been exceeded, we will then support an investigation to locate your shipment and contact you with the outcome.
          </p>
        </Toggle>

        <Toggle
          header={<h4 className="fs-16">Customs Duty &amp; Tax</h4>}
        >
          <p>
            Depending on your Delivery Destination your order may be subject to import duties and taxes which are applied when the delivery reaches that destination. Our standard delivery rates do not include import duties and taxes, these are the responsibility of the customer. The customer will be responsible for payment of any such import duties and taxes. The customer should contact his local customs office for further information before placing your order.
          </p>
        </Toggle>

        <Toggle
          header={<h4 className="fs-16">Can I amend the delivery address?</h4>}
        >
          <p>
            To be eligible for PayPal Seller Protection, item has to be shipped to the address the buyer provided in the Transaction Details. If there has been a mistake and address should be amended, the best way to proceed is to refund the order and have another one placed with the correct one.
          </p>
        </Toggle>
      </div>
    </div>
  </Panel>
)

Faq.contextTypes = {
  t: PropTypes.func.isRequired,
}

export default Faq



// WEBPACK FOOTER //
// ./src/views/Faq.js